import { getFlattenedCountryList } from '@/constants/pickerRegions/regions'

export const getSupportedLanguages = () => {
  const flattenedCountryList = getFlattenedCountryList()

  const supportedLanguages = Object.values(flattenedCountryList).flat()

  return supportedLanguages
}

export type SupportedLanguage = ReturnType<typeof getSupportedLanguages>[number]
